import gql from 'graphql-tag';

const KEY_STUDENT_PROGRESS_QUERY = gql`
  query getStudentProgressReport(
    $where: KeyStudentProgressReportWhereInput!
    $settingsWhere: PliStudentSettingsWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyStudentSettings(where: $settingsWhere) {
      oneHandedTypingHand
    }
    keyStudentProgressReport(where: $where, dateRange: $dateRange) {
      student {
        id
        gradeLevel
      }
      productCurriculumCode
      dateLastLogin
      curriculumProgress {
        activeDayCount
        activityCompletedCount
        activityTotalCount
        curriculumProgressPercentage
        curriculumWeek
        curriculumWeekTotal
        spotCheckCompletedCount
        spotCheckTotalCount
      }
      skipJumpInEnabled
      stopAndReviewEnabled
      stopAndReviewWeek
    }
  }
`;

export default KEY_STUDENT_PROGRESS_QUERY;
